import React from "react";
import "./AppFooter.scss";
import { theme, Layout, Typography, Button, Tooltip } from "antd";
import {
  FacebookOutlined,
  GlobalOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  SendOutlined,
  TikTokOutlined,
  WhatsAppOutlined,
  XOutlined,
  YoutubeOutlined,
} from "@ant-design/icons";
// import { FooterNavigation } from "./components";
import { useSelector } from "react-redux";

const { Footer } = Layout;

const SOCIAL_PLATFORMS = {
  facebook: { label: "Facebook", icon: FacebookOutlined },
  instagram: { label: "Instagram", icon: InstagramOutlined },
  x: { label: "X", icon: XOutlined },
  youtube: { label: "YouTube", icon: YoutubeOutlined },
  linkedin: { label: "LinkedIn", icon: LinkedinOutlined },
  tiktok: { label: "TikTok", icon: TikTokOutlined },
  whatsapp: { label: "WhatsApp", icon: WhatsAppOutlined },
  telegram: { label: "Telegram", icon: SendOutlined },
  website: { label: "Website", icon: GlobalOutlined },
  custom: { label: "Custom" },
};

export default function AppFooter() {
  const { useToken } = theme;
  const { token } = useToken();
  const { shop, loading: shopLoading } = useSelector(
    (state) => state?.shopDetails
  );

  const socialLinks = Array.isArray(shop?.extra_config?.social_links)
    ? shop.extra_config.social_links.filter(
        (link) =>
          link?.is_visible &&
          link?.url &&
          SOCIAL_PLATFORMS[link?.platform] &&
          (link?.platform !== "custom" || link?.image)
      )
    : [];

  return (
    <Footer
      className="appFooter-cont"
      style={{
        backgroundColor: token?.Layout?.footerBg,
        borderTop: `1px solid ${token?.Layout?.footerBorderTopColor}`,
      }}>
      <div className="appFooter-cont__socialMedia">
        {shopLoading ? (
          ""
        ) : shop?.name && shop?.is_name_visible_on_shop ? (
          <div className="appFooter-cont__socialMedia__titleWrapper">
            <Typography.Text
              className="appFooter-cont__socialMedia__titleWrapper__title"
              style={{
                color: token?.Typography?.colorPrimaryText,
              }}
              ellipsis={{
                tooltip: {
                  title: shop?.name,
                },
              }}>
              {shop?.name}
            </Typography.Text>
          </div>
        ) : (
          ""
        )}

        {socialLinks.length > 0 && (
          <div className="appFooter-cont__socialMedia__iconsWrapper">
            {socialLinks.map((link, index) => {
              const { label, icon: PlatformIcon } =
                SOCIAL_PLATFORMS[link.platform];
              // Only a title the shop typed is shown. The platform name is
              // kept for screen readers, it is never drawn as a tooltip.
              const linkTitle = link?.title?.trim() || "";
              const title = linkTitle || label;

              return (
                <Tooltip title={linkTitle} key={`${link.platform}-${index}`}>
                  <Button
                    type="link"
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={title}
                    icon={
                      link.platform === "custom" ? (
                        <img
                          className="appFooter-cont__socialMedia__iconsWrapper__customIcon"
                          src={link.image}
                          alt={title}
                        />
                      ) : (
                        <PlatformIcon
                          style={{
                            fontSize: "18px",
                            color: token?.icons?.whiteIcon,
                          }}
                        />
                      )
                    }
                  />
                </Tooltip>
              );
            })}
          </div>
        )}
        <div className="appFooter-cont__socialMedia__textWrapper">
          <Typography.Text
            className="appFooter-cont__socialMedia__textWrapper__text"
            style={{
              color: token?.Typography?.colorPrimaryText,
            }}>
            LICENSE #:
          </Typography.Text>
          <Typography.Text
            className="appFooter-cont__socialMedia__textWrapper__text"
            style={{
              color: token?.Typography?.mainColorText,
            }}>
            {shop?.license_number ? shop?.license_number : ""}
          </Typography.Text>
        </div>
        <div className="appFooter-cont__socialMedia__warningWrapper">
          <Typography.Text
            className="appFooter-cont__socialMedia__warningWrapper__text"
            style={{
              color: token?.Typography?.mainColorText,
            }}>
            YOU MUST BE 18 YEARS OF AGE OR OLDER TO VIEW OR SUBMIT INFORMATION
            {shopLoading
              ? ""
              : shop?.name && shop?.is_name_visible_on_shop
              ? ` TO ${shop?.name?.toUpperCase()}`
              : ""}
            .
          </Typography.Text>
        </div>
        <div className="appFooter-cont__socialMedia__warningWrapper">
          <Typography.Text
            className="appFooter-cont__socialMedia__warningWrapper__text"
            style={{
              color: token?.Typography?.mainColorText,
            }}>
            <Typography.Text
              className="appFooter-cont__socialMedia__warningWrapper__text"
              style={{
                color: token?.colorError,
                marginRight: "6px",
              }}>
              WARNING:
            </Typography.Text>
            CANNABIS IS A SCHEDULE I CONTROLLED SUBSTANCE. KEEP OUT OF REACH OF
            CHILDREN AND ANIMALS. CANNABIS PRODUCTS MAY ONLY BE POSSESSED OR
            CONSUMED BY PERSONS 21 YEARS OF AGE OR OLDER UNLESS THE PERSON IS A
            QUALIFIED MEDICINAL PATIENT. THE INTOXICATING EFFECTS OF CANNABIS
            PRODUCTS MAY BE DELAYED UP TO TWO HOURS. CANNABIS USE WHILE PREGNANT
            OR BREASTFEEDING MAY BE HARMFUL. CONSUMPTION OF CANNABIS PRODUCTS
            IMPAIRS YOUR ABILITY TO DRIVE AND OPERATE MACHINERY. PLEASE USE
            EXTREME CAUTION.
          </Typography.Text>
        </div>
      </div>
    </Footer>
  );
}
